<div mat-dialog-content>
  <app-newsletter (submitSuccess)="dialogRef.close()"></app-newsletter>
</div>
<div mat-dialog-actions>
  <div class="d-flex justify-content-end w-100">
    <button class="btn btn-primary" type="submit" [mat-dialog-close]="true">{{'NEWSLETTER.CLOSE-BUTTON'|translate}}</button>
  </div>
</div>
